import { HttpResponse, httpService } from '../core/http'
import {
  NonPaginatedResponseData,
  PaginatedRequest,
  PaginatedResponseData
} from '../core/interfaces'
import { Order, OrderToSave } from '../entities'

export const getAllServiceOrders = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<Order>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/orders/service-orders',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getServiceOrderById = async (
  params: any
): Promise<NonPaginatedResponseData<Order>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `orders/service-orders/${params.id}`
    )
    return httpResponse.data
  } catch (error) {
    return error
  }
}
